<template>
    <div class="action-bar">
        <b-navbar toggleable="md" type="dark" variant="info">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand href="#">Harven Surf</b-navbar-brand>            
            <b-nav-text href="#">Caja:{{caja}} - Almacén:{{location}} - Usuario POS: {{this.$store.state.UserCardId.return_value}} - Documento: {{this.$store.state.curOrder}}</b-nav-text>            
            <b-collapse is-nav id="nav_collapse">
             
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item to="pos">Volver a venta</b-nav-item>   
                </b-navbar-nav> 
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
var axios = require('axios')
import mixin from '@/components/mixin.js'

export default {
    mixins:[mixin],
    name: 'ActionBarPayment',
    data() {
        return {
            form: {
                CardId: ''                
            },
            alertvariant : "warning",             
            alerttxt: "",
            dismissCountDown : 0,
            caja: localStorage.getItem("posId"),
            location: localStorage.getItem("defaultlocation")
        }
    },    
    methods: {
        park(){
            this.parkSale().then((data) => {
                this.$store.dispatch("resetPOS")
                this.$router.push('setup')
            })
        }        
    }
}
</script>